import * as React from "react"
 
class MenuLinks extends React.Component {
  mouseClick(e) {
    e.preventDefault();
    var link = e.target.closest('.menu--link').getAttribute('href');  
    document.querySelector('.bottom-menu--fixed').classList.add('is-transitioning');  
    document.querySelector('.loader-icon').classList.add('is-rotating');  
    document.querySelector('.overlay--menu').classList.add('in-transition');
    document.querySelector('.overlay--menu').style.backgroundColor = '#000';
    setTimeout(function(){ 
      document.querySelector('.preloader').classList.add('fade-in'); 
    }, 500);
    setTimeout(function(){ 
      window.location.href = link; 
    }, 1000);
  }
 
  render() {

    const Link = ({link, title, arrow, delay, align, margin}) => {
      return (
        <div className="title--animation-wrapper">
          <div className={"text-wrapper hm first text-"+align}>
            <a className='arrow-expand menu--link' href={link} role="menu" onClick={this.mouseClick}>
              <div className="title--animation">
                <span className="text-wrapper delay-"><span className={"word pl10 pr10 delay-"+delay}>{title}</span> <div className={margin+" arrow-icon delay-"+delay} data-scroll>→</div></span>
              </div>
            </a>
          </div>
        </div> 
      )
    } 

    return (
      <div className="internal-page--links w-100" role="presentation"> 
        <div className="max-750 ma w-100 m-w-100a p30">
         
          <Link title="Home" link="/" delay="100" align="center" /> 

          <Link title="Approach" link="/approach" delay="200" /> 

          <Link title="Folio" link="/portfolio" delay="300" /> 

          <Link title="Films" link="/films" align="right" delay="400" margin="mr30" /> 

          <Link title="About" link="/about" delay="500" /> 

          <Link title="Contact" link="/contact" align="center" delay="600" /> 

        </div>
      </div> 
    )
  } 
} 

export default MenuLinks

